<template>
    <div class="sta-table-1">
      <CTable class="table-queue"
              :head="head"
              :body="longQueue"
      >
           <template slot="class1_class3" slot-scope="{data}">
             <span>{{data.class1}} - {{data.class3}}</span>
            </template>
           <template slot="period" slot-scope="{data}">
             <span>{{data.period}}期</span>
            </template>
      </CTable>
    </div>
</template>

<script>
import CTable from '../../dialog/table';
import {mapState} from 'vuex';

  export default {
    name: "sta_table1",
    components: {CTable},
    computed: {
      head() {
          return [
          {label: '长龙类型', value: 'class1_class3'},
          {label: '期数', value: 'period'}
        ];
      },
      ...mapState({
        longQueue: state => state.home.longQueue
      })
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/c_statistics/sta-table/sta_table1.vue